export const routes = {
  login: '/',
  dashboard: '/inicio',
  clients: '/clientes',
  clientsList: '/clientes/list',
  clientDetail: '/clientes/:cuit',
  risksAnalysis: '/analisisderiesgo',
  committee: '/comite',
  instrumentation: '/instrumentacion',
  finishedFolders: '/carpetas-finalizadas',
  dashboardComercial:'/dashboard',
  confirmation: '/confirmacion',
  users:'/usuarios',
  guarantees: '/avales',
  guaranteeDetail: '/avales/:cuit',
  productLineDetail: '/avales/:cuit/linea/:id',
  loanDetail: '/avales/:cuit/linea/:lineId/prestamo/:id',
  checkDetail: '/avales/:cuit/linea/:lineId/cheque/:id',
  promissoryNoteDetail: '/avales/:cuit/linea/:lineId/pagare/:id',
  commercialEndorsementDetail: '/avales/:cuit/linea/:lineId/aval-comercial/:id',
  annexes: '/anexos',
  annexDetail: '/anexos/:id',
  newAnnex: '/anexos/new',
  monetization: '/monetizacion',
  newMonetization: '/monetizacion/new',
  editMonetization: '/monetizacion/edit/:id',
  overdue: '/vencimientos',
  fundsAndProtectors: '/protectores',
  protectorDetail: '/protectores/:id',
  protectorNew: '/protectores/new',
  protectorContributionNew: '/protectores/:id/aportes/new',
  partners: '/configuracion/socios',
  settings: '/configuracion',
  rateTypes: '/configuracion/tasas',
  sgr: '/configuracion/sgr',
  funds: '/configuracion/fondos',
  assetsToIntegrate: '/configuracion/activos',
  quotations: '/configuracion/cotizaciones',
  quotationsDetail: '/configuracion/cotizaciones/:assetCode',
};
